var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeExclamationHollow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 37C74 57.4345 57.4345 74 37 74C16.5655 74 0 57.4345 0 37C0 16.5655 16.5655 0 37 0C57.4345 0 74 16.5655 74 37ZM5.29724 37C5.29724 54.509 19.491 68.7028 37 68.7028C54.509 68.7028 68.7028 54.509 68.7028 37C68.7028 19.491 54.509 5.29724 37 5.29724C19.491 5.29724 5.29724 19.491 5.29724 37Z",
    fill: "#FFAF66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 15H42.25L41.5733 44.6H33.6283L33 15Z",
    fill: "#FFAF66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.625,
    cy: 53.6475,
    r: 4.625,
    fill: "#FFAF66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeExclamationHollow);
export default __webpack_public_path__ + "static/media/orange-exclamation-hollow.8b43314c.svg";
export { ForwardRef as ReactComponent };